
<template>
	<div>
		<compWrapper title="基础信息" theme="primary">
			<compFormEdit ref="saveForm" class="margin-layout" :formdata="getBase" v-model="inputData" :rules="formRules"></compFormEdit>
            <div v-if="temptype == 4" class="button-container">
                <Button class="margin-right-15" type="primary" @click="saveOne">保存</Button>
                <Button type="default" @click="cancel">取消</Button>
            </div>
		</compWrapper>
		<!-- 仓库作业费 增值服务费模板详情 包材费-->
		<compWrapper :title="getRateName" theme="primary">
			<vButtonGroup class="margin-layout" v-if="temptype==4">
				<vButton theme="primary" @click="handleOperates('add')">添加</vButton>
				<vButton theme="success" @click="handleOperates('import')">导入</vButton>
				<vButton @click="handleOperates('export')">导出</vButton>
				<vButton @click="handleOperates('delete')">批量删除</vButton>
			</vButtonGroup>
			<vButtonGroup v-else slot="footer">
				<vButton theme="primary" @click="submit">批量保存</vButton>
				<vButton @click="cancel">返回</vButton>
			</vButtonGroup>
			<vTableSimple
				class="margin-layout"
				:columns="getColumns"
				:data="dataList"
				@on-check-change="handleChecked"
			></vTableSimple>
		</compWrapper>

		<!-- 弹框 -->
		<compModal
			v-model="operate.show"
			v-bind="operate"
			@on-close="operate.show=false"
			@on-confirm="getDetail"
		>
			<component
				v-if="operate.component"
				:is="operate.component"
				v-bind="operate"
				@on-close="operate={}"
				@on-update="getDetail"
				@on-success="getDetail"
			/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>
<script>
import { HttpGetTemplateWarehouse, HttpSaveTemplateWarehouse, HttpGetCusLog, HttpGetTempalteStorage, HttpDelTempalteStorage, HttpCusbillTemplateList } from '@/service/costbilling';
import { HttpMaterialTemplate, HttpSaveMaterialTemplate, HttpSaveTransactionTemplate, HttpTransactionTemplate, HttpSaveCusTemplateCode } from '@/service/costbilling';
import { mapGetters } from "vuex";
import compStoragetemp from './storageTemp'

export default {
	components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormQuery: () => import('@components/templates/formquery'),
		compLog: () => import("@components/templates/log"),
		compModal: () => import("@components/templates/modal"),
		compStoragetemp,
		compUpload: () => import("@components/templates/upload"),
	},
	data() {
		return {
			loading: false,
            formData: {},
            inputData: {},
			dataList: [],
			id: this.$route.query.id,
			temptype: this.$route.query.temptype,
			// type: this.$route.params.type,
			// logList: [],
			operate: {
				show: false,
				loading: false
			},
			checkedId: [],
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
        formRules () {
            return {
                'chargingUnit': {
                    required: true,
                    message: '此项不能为空，请填写'
                },
                'minimumBillableValue': {
                    trigger: "blur",
                    validator: (rule, value = "", callback) => {
                        if (!value) {
                            callback();
                        } else {
                            if (/[0-9]*/g.test(value) && Number(value) > 0) {
                                callback();
                            } else {
                                callback(new Error("请输入大于0的正整数"));
                            }
                        }
                    },
                },
            }
        },
		getRateName(){
			const typeMap = {
				1: '(仓库作业费)',
				4: '(仓储费)',
				5: '(包材费)',
				3: '(增值服务费)'
			};
			return '费率设置'+typeMap[this.temptype]
		},
		getBase() {
			return [
				{
                    query: true,
					label: "code",
					key: "code",
				}, {
                    query: true,
					label: "模板名称",
					key: "name",
				}, {
                    show: this.temptype == 4 ? true : false,
                    query: false,
                    label: '计费单位',
                    key: "chargingUnit",
                    tag: 'vSelect',
                    options: [
                        {
                            label: "（体积）立方英尺",
                            value: 1,
                        },
                        {
                            label: "（体积）立方米",
                            value: 2,
                        },
                    ],
                }, {
                    show: this.temptype == 4 ? true : false,
                    query: false,
                    label: "最低计费值",
                    tag: "vInput",
                    key: "minimumBillableValue",
                }, {
                    query: true,
					label: "计费币种",
					key: "currency",
				}, {
                    query: true,
					label: "备注",
					key: "remark"
				}
			];
		},
		//按照类型获取 columns
		getColumns() {
			const typeMap = {
				1: 'getWareColums',
				4: 'getStorageColumns',
				5: 'getMaterialColumns',
				3: 'getServiceColumns'
			};
			return this[typeMap[this.temptype]]
		},
		//仓库作业费模板详情
		getWareColums() {
			return [
				{
					title: "NO",
					type: 'index'
				},
				{
					title: "一级分类",
					key: 'firstCategoryName'
				},
				{
					title: "二级分类",
					key: 'secondCategoryName'
				},
				{
					title: "三级分类",
					key: 'thirdCategoryName'
				},
				{
					title: "客户费率",
					key: 'rate',
					// renderHeader: (h, params) => {
					// 	return <strong>客户费率</strong>
					// },
					render: (h, { row, index }) => {
						return h('vInput', {
							props: {
								value: row.rate
							},
							on: {
								'on-change': (val) => {
									this.$set(this.dataList[index], 'rate', val)
								}
							},
						})
					}
				},
				{
					title: "币种",
					key: 'currency',
				},
				{
					title: "历史记录",
					render: (h, { row, index }) => {
						return <vButton theme="error" size='small' onClick={this.handleModal.bind(this, row.thirdCategoryId, 'log')}>历史记录</vButton>
					}
				},
			]
		},
		//增值服务费模板详情
		getServiceColumns() {
			return [{
				title: '#',
				type: 'index',
				width: 40,
				align: 'center',
			}, {
				title: '处理项名称',
				key: "transactionName"
			}, {
				title: '处理项Code',
				key: 'transactionCode',
			}, {
				title: '计费值来源',
				key: 'billingSourcesType',
				render(h, { row }) {
					return row.billingSourcesType == 'FIXED' ? '固定值' : '手工录入'
				}
			}, {
				title: '费率',
				key: 'costValue',
				render: (h, { row, index }) => {
					const tag=row.billingSourcesType == 'FIXED'?'vInputNumber':'vInput';
					return h(tag, {
						props: {
							value: row.costValue,
							min:0
						},
						on: {
							'on-change': (val) => {
								this.$set(this.dataList[index], 'costValue', val)
							}
						}
					})
					// return <vInput onOnChage={}></vInput>
				}
			}, {
				title: '币种',
				key: 'currency',
			}, {
				title: '历史记录',
				render: (h, { row }) => {
					return <vButton theme="error" size='small' onClick={this.handleModal.bind(this, row.id, 'log')}>历史记录</vButton>
				}
			}]
		},
		//包材费
		getMaterialColumns() {
			return [{
				title: '#',
				type: 'index',
				width: 40,
				align: 'center',
			}, {
				title: '仓库',
				key: "warehouseCode"
			}, {
				title: '包材名称',
				key: 'name',
			}, {
				title: '包材Code',
				key: 'materialCode',
			}, {
				title: '费率',
				key: 'cost',
				render: (h, { row, index }) => {
					return h('vInputNumber', {
						props: {
							value: row.cost,
							min:0
						},
						on: {
							'on-change': (val) => {
								this.$set(this.dataList[index], 'cost', val)
							}
						}
					})
				}
			}, {
				title: '币种',
				key: 'currency',
			}, {
				title: '更新时间',
				key: 'updatedAt',
			}, {
				title: '历史记录',
				render: (h, { row }) => {
					return <vButton theme="error" size='small' onClick={this.handleModal.bind(this, row.id, 'log')}>历史记录</vButton>
				}
			}]
		},
		//仓储费
		getStorageColumns() {
			return [
				{
					type: 'selection',
					width: 40,
					align: 'center',
					formName: 'id'
				},
				{
					title: "NO",
					type: 'index'
				},
				{
					title: "操作",
					render: (h, { row, index }) => {
						let { id } = row
						return <vDropdown placement="bottom-start" trigger="click">
							<vButton size='small' theme='info'>操作 <vIcon type="arrow-dropdown" /></vButton>
							<template slot="list" class="text-left">
								<vDropdownItem nativeOnClick={this.handleOperates.bind(this, 'edit', id)}>编辑</vDropdownItem>
								<vDropdownItem nativeOnClick={this.handleOperates.bind(this, 'log', id)}>历史操作</vDropdownItem>
								<vDropdownItem nativeOnClick={this.handleOperates.bind(this, 'delete', id)}>删除</vDropdownItem>
							</template>
						</vDropdown >
					}
				},
				// {
				// 	title: "计费单位",
				// 	render: (h, { row }) => {
				// 		switch (row.unit) {
				// 			case 'BILL_UNIT_CUBIC_FOOT': return '立方英尺'; break;
				// 		}
				// 	}
				// },
				{
					title: "库存类型",
					render: (h, { row }) => {
						switch (row.inventoryType) {
							case 'CAN_SALE': return '可售库存'; break;
							case 'NO_SALE': return '不可售库存'; break;
						}
					}
				},
				{
					title: "存储天数（起）",
					key: 'storageStart'
				},
				{
					title: "存储天数（止）",
					key: 'storageEnd'
				},
				{
					title: "费率",
					key: 'rate'
				},
				{
					title: "币种",
					key: 'currency',
				},
				{
					title: "更新时间",
					key: 'updatedAt',
				},

			]
		},
		getLogColums() {
			return [
				{
					title: "NO",
					type: 'index'
				},
				{
					title: "字段",
					render:(h,{row})=>{
						switch(row.field){
							case 'inventoryType': return '库存类型'; break;
							case 'storageStart': return '储存起始天数'; break;
							case 'storageEnd': return '储存结束天数'; break;
							case 'rate': return '费率'; break;
						}
					}
				},
				{
					title: "修改前",
					key: 'beforeValue'
				},
				{
					title: "修改后",
					key: 'afterValue'
				},
				{
					title: "操作人",
					key: 'updatedName'
				},
				{
					title: "操作时间",
					key: 'updatedAt',
				},
			]
		}
	},
	methods: {
        async saveOne () {
            let flag = true;
            await this.$refs.saveForm.validate(valid => {
                flag = valid;
            });
            if (!flag) return;
            // return console.log(this.inputData);
            let { minimumBillableValue, chargingUnit, ...requestData } = {
                ...this.inputData
            }
            let meta = JSON.stringify({
                minimumBillableValue,
                chargingUnit
            })
            HttpSaveCusTemplateCode({
                id: this.id,
                organizationId: global.SYSID,
                type: this.temptype,
                ...requestData,
                meta
            }).then(res => {
                this.$Message.success(res.message);
            }, err => {
                this.$Message.error(err.message);
            })
        },
		handleModal(data, type) {
			if (type === 'log') {
				// templateId: this.id,
				// itemId: thirdCategoryId
				this.operate = {
					show: true,
					width: 'normal',
					component: 'compLog',
					title: '历史记录',
					showFooter: false,
					ajaxRequest: HttpGetCusLog,
					params: {
						templateId: this.id,
						itemId: data
					},
					columns: this.getLogColums
				}
				return;
			}
		},
		handleChecked(rows, val) {
			this.checkedId = val;
		},
		handleOperates(type, data) {
			switch (type) {
				case 'add':
					this.operate = {
						title: '添加',
						show: true,
						width: 'middle',
						operatype: 'add',
						component: "compStoragetemp",
						showFooter: false,
					}
					break;
				case 'edit':
					this.operate = {
						title: '编辑',
						show: true,
						activeids: data,
						width: 'middle',
						operatype: 'edit',
						component: "compStoragetemp",
						showFooter: false,
					}
					break;
				case 'export':
					this.handleWebfs(
						process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/billingCostWarehouseStorage/exportInfo", { templateId: this.id },
						"download"
					);
					break;
				case 'import':
					this.operate = {
						show: true,
						title: '导入数据',
						width: 460,
						showFooter: false,
						data: { templateId: this.id },
						action: process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/billingCostWarehouseStorage/importInfo",
						name: "excelFile",
						component: "compUpload",
						download: () => {
							this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/billingCostWarehouseStorage/warehouseStorageTemplate", {}, 'download')
						},
					}
					break
				case 'log': this.handleModal(data, 'log'); break;
				case 'delete':
					this.checkedId = !data ? this.checkedId : [data];
					if (this.checkedId.length == 0) {
						this.$VMessage.warning('请选择至少一条数据');
						return;
					}
					this.operate = {
						show: true,
						alert: "error",
						params: { ids: this.checkedId },
						title: "删除",
						ajaxRequest: HttpDelTempalteStorage
					}
					break;

			}
		},
		getDetail() {
			this.operate={};
			this.loading = false;
			HttpCusbillTemplateList({
				page: 1,
				rows: 1,
				// sidx: 'id',
				// sord: 'desc',
				'search[EQ_id]': this.id,
			}).then(res => {
                this.formData = res.data.content[0];
                let meta = this.formData.meta ? JSON.parse(this.formData.meta) : {};
                this.inputData = {
                    code: this.formData.code,
                    name: this.formData.name,
                    remark: this.formData.remark,
                    currency: this.formData.currency,
                    chargingUnit: meta.chargingUnit,
                    minimumBillableValue: meta.minimumBillableValue
                }
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
			this.getRateDetail();
		},
		// 获取费率模板
		getRateDetail() {
			let ajax, temptype = this.temptype;
			if (temptype == 4) ajax = HttpGetTempalteStorage;
			if (temptype == 1) ajax = HttpGetTemplateWarehouse;
			if (temptype == 5) ajax = HttpMaterialTemplate;
			if (temptype == 3) ajax = HttpTransactionTemplate;
			if (!ajax) return;
			this.loading = true;
			ajax({ type: this.temptype, templateId: this.id }).then(res => {
				this.dataList = res.data.templateItems;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//包材模板保存
		submitMaterial() {
			this.loading = true;
			HttpSaveMaterialTemplate({ billingTemplateId: this.id, packageMaterialTempItems: this.dataList }).then(res => {
				this.getDetail();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//事务项模板保存
		submitService() {
			this.loading = true;
			HttpSaveTransactionTemplate({ billingTemplateId: this.id, processedTransactionTempItems: this.dataList }).then(res => {
				this.getDetail();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},

		//仓库作业费模板保存
		submitWarehouse() {
			this.loading = true;
			HttpSaveTemplateWarehouse({ billingTemplateId: this.id, warehouseOperationTempItems: this.dataList }).then(res => {
				this.getDetail();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		submit() {
			const typeMap = {
				1: 'submitWarehouse',
				5: 'submitMaterial',
				3: 'submitService'
			};
			const ajax = typeMap[this.temptype];
			if (ajax) this[ajax]();
		},
		cancel() {
			this.$router.push({ name: 'costbillingRateTemplatelist' });
		},
	}
};
</script>
